import { EventSource } from 'eventsource'
import eventBus from 'vue3-eventbus'
import { useCrossDomainCookie } from '@/composables/useCrossDomainCookie'
import useUserStore, { useUserStoreHook } from "~/store/modules/user"
const { createCrossDomainCookie, getCrossDomainCookie } = useCrossDomainCookie()


export enum AIMessageType {
	TXT = '1',  // text message  文本
	FILE_TXT = '2', // file and text message 图文
	FILE = '3', // pdf message // 文件
}
export type TMessageItem = {

}
// 发送消息的状态
export enum SMSTATUS {
	SENDING = 'sending', // 发送中
	SUCCESS = 'success', // 成功
	FAIL = 'fail', // 失败
	WAIT = 'wait', // 等待
}
// 服务器消息状态
export enum RMSTATUS {
	SUCCESS = 'success', // 成功
	FAIL = 'fail', // 失败
}

class AIMessageObserver {
	eventSource : EventSource | undefined;
	constructor() { }
	connect(param, isAiTranslate: boolean = false) {
		console.log("eventSource sendMessage", param, this.eventSource)
		if (this.eventSource) return;
		
		let url = useRuntimeConfig().public.apiUrl + "/api/core/ai/chat/askstream"
		if (isAiTranslate) {
			url = useRuntimeConfig().public.apiUrl + "/api/core/ai/translate/askstream"
		}
		this.eventSource = new EventSource(url, {
			fetch: (input, init) => {
				console.log("eventSource sendMessage222", param)

				function getBrowserInfo()
                {
                    var agent = navigator.userAgent.toLowerCase() ;

                    var regStr_ie = /msie [\d.]+;/gi ;
                    var regStr_ff = /firefox\/[\d.]+/gi
                    var regStr_chrome = /chrome\/[\d.]+/gi ;
                    var regStr_saf = /safari\/[\d.]+/gi ;
                    //IE
                    if(agent.indexOf("msie") > 0)
                    {
                        return agent.match(regStr_ie) ;
                    }

//firefox
                    if(agent.indexOf("firefox") > 0)
                    {
                        return agent.match(regStr_ff) ;
                    }

//Chrome
                    if(agent.indexOf("chrome") > 0)
                    {
                        return agent.match(regStr_chrome) ;
                    }

//Safari
                    if(agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0)
                    {
                        return agent.match(regStr_saf) ;
                    }

                }
				let isDevelopment = import.meta.env.DEV
				const deviceId = getCrossDomainCookie('deviceId').value || localStorage.getItem("deviceId") || ""
                const token = isDevelopment ? useCookie('pdf_token') : getCrossDomainCookie('pdf_token')
                const currentToken = token.value || ''
                const lang = useCookie('lang') || getCrossDomainCookie('lang') || ""
                const browserInfo = getBrowserInfo() || []

				let langCode = ""
                if (lang.value) {
                    langCode = lang.value
                    if (lang.value == 'zh') {
                        langCode = "zh-CN"
                    }else if (lang.value == 'hi') {
                        langCode = "hib"
                    }else if (lang.value == 'tw') {
                        langCode = "zh-TW"
                    }
                }
				let headers = {
					"Accept": "text/event-stream",
					'Content-Type': "application/json;",
					'deviceId': deviceId,
					'internationalCode': langCode,
					'clientType': "web",
					'appSource': "web",
					'deviceName': browserInfo.length > 0 ? browserInfo[0] : '',
				}
				if (currentToken) {
					headers['token'] = currentToken
					headers['streamtoken'] = currentToken
					if (useUserStore().userInfo?.bizTeamId) {
						headers['bizteamid'] = useUserStore().userInfo.bizTeamId
					}
				}

				return fetch(input, {
					...init,
					headers: headers,
					method:"POST",
					body: JSON.stringify(param)
				})
			}
		})
		
		this.eventSource.addEventListener('[DATA]', (e : any)=>{
			console.log('eventSource DATA',  Date.now());
			this.receiveMessage(e.data)
		});
		
		this.eventSource.addEventListener('[FINISH]', (e : any)=>{
			console.log('eventSource FINISH', Date.now(), e.data);
			eventBus.emit('eventSourceSuccess', e.data)
			this.closeEventSource()
		});
		
		this.eventSource.addEventListener('[ERROR]', (e : any)=>{
			console.log('eventSource ERROR',e.data, Date.now());
			eventBus.emit('eventSourceFail', e.data)
			this.closeEventSource()
		});
		
		this.eventSource.addEventListener('error', (e : any)=>{
			console.log('eventSource error', e);
			eventBus.emit('eventSourceConnetFail', e.data)
			this.closeEventSource()
		});
		console.log(this.eventSource)
	}

	receiveMessage(data : string) {
		console.log("receiveMessage", data)
		eventBus.emit('eventSourceOutPutText', data)
	}

	closeEventSource() {
		this.eventSource && this.eventSource.close()
		this.eventSource = null
	}
}
export default AIMessageObserver;
